import { useState } from 'react';
import { useNotify } from 'react-admin';
import { Card, CardContent, Stack, Switch, Typography } from '@mui/material';
import { card, typo } from '../styles/ds';
import { websiteRequest } from './websiteApi';

/**
 * WD-006: a CRM Admin marks a customer eligible for "Shluchim only" coupons
 * (audited). Applies on the website when this customer is linked to the
 * shopper's website account (website accounts page).
 */
const ShluchimEligibility = ({ customer }) => {
  const notify = useNotify();
  const [eligible, setEligible] = useState(Boolean(customer.shluchim_eligible));
  const [saving, setSaving] = useState(false);

  const toggle = async () => {
    setSaving(true);
    try {
      const r = await websiteRequest(`/customers/${customer.id}/shluchim`, 'PUT', { eligible: !eligible });
      setEligible(r.shluchim_eligible);
      notify(r.shluchim_eligible ? 'הלקוח סומן כזכאי להטבת שלוחים' : 'הסימון בוטל', { type: 'success' });
    } catch (err) { notify(err.message, { type: 'error' }); }
    finally { setSaving(false); }
  };

  return (
    <Card sx={card.section}>
      <CardContent className="crm-card-content" sx={{ p: 3 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <div>
            <Typography sx={typo.sectionTitle}>זכאי להטבת שלוחים</Typography>
            <Typography sx={typo.meta}>
              קופונים לשלוחים בלבד עובדים באתר רק ללקוח מסומן, כשחשבון האתר שלו מקושר לכרטיס הזה.
            </Typography>
          </div>
          <Switch checked={eligible} disabled={saving} onChange={toggle}
            slotProps={{ input: { 'aria-label': 'זכאי להטבת שלוחים' } }} />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ShluchimEligibility;
